<template>
  <div id="warning">
    <h1 v-lang.header></h1>
    <p v-lang.body></p>
    <router-link :to ="{name: 'Index'}">Home</router-link>
  </div>
</template>
<script>
  export default {
    name: 'NotFound',
    messages: {
      en: {
        header: '404 - Not found',
        body: "We couldn't find the requested page"
      },
      de: {
        header: '404 - Nicht gefunden',
        body: 'Wir konnten die angeforderte Seite leider nicht finden.'
      }
    }
  };
</script>
<style scoped>
  #warning {
    color: black;
    display: block;
    margin-left:  auto;
    margin-right: auto;
    padding-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/not_found.vue